import { render } from "./SliderTables.vue?vue&type=template&id=56786972&scoped=true"
import script from "./SliderTables.vue?vue&type=script&lang=js"
export * from "./SliderTables.vue?vue&type=script&lang=js"

import "./SliderTables.vue?vue&type=style&index=0&id=56786972&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56786972"]])

export default __exports__